import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ICodeCoverageResult } from '../shared/codeCoverage';

@Injectable()
export class CodeCoverageService {
  constructor(private http: HttpClient) { }

  getAll(): Observable<ICodeCoverageResult[]> {
    return this.http.get<ICodeCoverageResult[]>('/api/codecoverage');
  }

  refresh(): Observable<any> {
    return this.http.post('/api/codecoverage/refresh', {});
  }
}
